import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  ApplicationBar,
  TestIdUtil,
} from '@gen-epix/ui';
import type { ApplicationHeaderProps } from '@gen-epix/ui';

import LogoRivm from '../../assets/logo/logo-rivm.svg?react';


export const ApplicationHeader = ({
  fullHeight,
  fullWidth,
  singleAction,
}: ApplicationHeaderProps) => {
  const [t] = useTranslation();

  return (
    <Box
      {...TestIdUtil.createAttributes('ApplicationHeader')}
      sx={{
        position: 'relative',
        zIndex: 3,
      }}
    >
      {!fullHeight && (
        <Box
          sx={{
            '& svg': {
              height: '100%',
              maxHeight: '100%',
              width: 'auto',
            },
            display: 'flex',
            height: '100px',
            justifyContent: 'center',
            maxHeight: '100px',
          }}
        >
          <LogoRivm aria-label={t`Rijksoverheid logo met woordmerk: Rijksinstituut voor Volksgezondheid en Milieu Ministerie van Volksgezondheid, Welzijn en Sport.`} />
        </Box>
      )}
      <ApplicationBar
        fullHeight={fullHeight}
        fullWidth={fullWidth}
        singleAction={singleAction}
      />
    </Box>
  );
};
